export const defaultToolbarConfig = [
  [{ header: [1, 2, 3, false] }],
  [{ font: [] }, { size: [] }],
  ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code'],
  [{ color: [] }, { background: [] }],
  [{ script: 'sub' }, { script: 'super' }],
  [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
  [{ align: [] }, { direction: 'rtl' }],
  ['link', 'image', 'emoji', 'code-block'],
];

export const EMPTY_TOOLBAR_HANDLERS = {};
export const EMPTY_RICH_TEXT_VALUE = '<p><br></p>';

export const EMPTY_CHAR = '\u200B';
export const SPACE_CHAR = '\u00A0';

export const MAX_FILE_SIZE_MB = 5;

export const TRIGGER_BOX_VERTICAL_OFFSET = 4;
export const TRIGGER_BOX_CLOSE_KEYS = [
  'Enter',
  'Tab',
  'Escape',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
  'PageUp',
  'PageDown',
];

export const MENU = 'menu';
export const TRIGGER_FIELDS = 'triggerFields';
